import { render, staticRenderFns } from "./ApprenticeDetailView.vue?vue&type=template&id=4dc96fa4&scoped=true&"
import script from "./ApprenticeDetailView.ts?vue&type=script&lang=js&"
export * from "./ApprenticeDetailView.ts?vue&type=script&lang=js&"
import style0 from "./ApprenticeDetailView.css?vue&type=style&index=0&id=4dc96fa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc96fa4",
  null
  
)

export default component.exports